'use client'
import React, { FC, ReactNode } from 'react'
import { useTrackPageView } from 'storefront-modules/third-party'
import appConfig from '#/src/appConfig'

interface AppComponentProps {
  children: ReactNode
}

const AppComponent: FC<AppComponentProps> = ({ children }) => {
  useTrackPageView({ categories: appConfig.categories })

  return <>{children}</>
}

export default AppComponent
